/** @format */

import { useState, useEffect } from "react";
import { collection, getDocs, query, limit } from "firebase/firestore";
import { db } from "../firebase/config";

export const useSimpleUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        console.log("🔍 Fetching users...");
        setLoading(true);

        // Simple query with limit
        const usersQuery = query(collection(db, "users"), limit(50));
        const usersSnapshot = await getDocs(usersQuery);

        console.log(`✅ Found ${usersSnapshot.size} users`);

        const usersData = usersSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setUsers(usersData);
        setError(null);
      } catch (err) {
        console.error("❌ Error fetching users:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return {
    users,
    loading,
    error,
    refetch: () => window.location.reload(), // Simple refresh
  };
};
